import { RouteObject } from 'react-router-dom';
import { FeatureFlag } from 'shared/settings/FeatureToggles';
import { ProfileACHPaymentInfoPage } from '../../profile/ProfileACHPaymentInfoPage';
import { ProfileBillingInfoPage } from '../../profile/ProfileBillingInfoPage';
import { ProfileBusinessLicensePage } from '../../profile/ProfileBusinessLicensePage';
import { ProfileCargoInsurancePage } from '../../profile/ProfileCargoInsurancePage';
import { ProfileCarrierInfoPage } from '../../profile/ProfileCarrierInfoPage';
import { ProfileStateMotorCarrierPermitPage } from '../../profile/ProfileStateMotorCarrierPermit';
import { ProfileTermsAndConditionsPage } from '../../profile/ProfileTermsAndConditionsPage';
import { ProfileTransporterPlateRegistrationPage } from '../../profile/ProfileTransporterPlateRegistrationPage';
import { ProfileW9Page } from '../../profile/ProfileW9Page';
import { verifiedCarrierApplicationRoutes } from '../../profile/verified-carrier-application/ProfileVerifiedCarrierApplicationOutlet';
import { CarrierWebviewNavigationMenuPage } from './CarrierWebviewNavigationMenuPage';
import { CarrierOverviewScreenPage } from './overview/CarrierOverviewScreenPage';
import { ProfilePhoneVerificationPage } from './ProfilePhoneVerificationPage';
import { ProfileWebviewPage } from './ProfileWebviewPage';

export const profileWebViewRoutes: RouteObject[] = [
  {
    path: 'profile',
    children: [
      ...verifiedCarrierApplicationRoutes,
      {
        index: true,
        element: (
          <FeatureFlag
            feature="carrier_onboarding_packets_webview"
            fallback={<ProfileWebviewPage />}
          >
            <CarrierWebviewNavigationMenuPage />
          </FeatureFlag>
        ),
      },
      { path: 'details', element: <ProfileWebviewPage /> },
      { path: 'overview', element: <CarrierOverviewScreenPage /> },
      { path: 'phone-verification', element: <ProfilePhoneVerificationPage /> },
      { path: 'carrier-info', element: <ProfileCarrierInfoPage /> },
      { path: 'cargo-insurance', element: <ProfileCargoInsurancePage /> },
      { path: 'w9', element: <ProfileW9Page /> },
      {
        path: 'transporter-plate-registration',
        element: <ProfileTransporterPlateRegistrationPage />,
      },
      {
        path: 'state-motor-carrier-permit',
        element: <ProfileStateMotorCarrierPermitPage />,
      },
      { path: 'business-license', element: <ProfileBusinessLicensePage /> },
      { path: 'billing-info', element: <ProfileBillingInfoPage /> },
      {
        path: 'terms-and-conditions',
        element: <ProfileTermsAndConditionsPage />,
      },
      {
        path: 'ach-payment',
        element: <ProfileACHPaymentInfoPage />,
        children: [{ path: 'change-bank-details', element: null }],
      },
    ],
  },
];
